// Responsive column height shared by the center card and side panels.
// Bounded by design max (700px), viewport height, and viewport width.
export const COLUMN_HEIGHT =
  "min(700px, calc(100vh - 96px), calc((100vw - 128px) * 569 / 1104))";

export const PERKS_QUIRKS_XP = 10;
export const JOB_GEAR_XP = 5;
export const HIGH_SCHOOL_PRIORITIES_XP = 10;
export const AFTER_HIGH_SCHOOL_XP = 10;

// Instructional prompt shown between the activity name and its XP on the
// front-side Activities panel, ordered by the intended instructional flow.
export const ACTIVITY_PROMPTS = {
  perksQuirks: "Could this work be for me?",
  jobGear: "What tools will I use?",
  highSchoolPriorities: "What’s my next step?",
  afterHighSchool: "What can I do after graduation?",
} as const;

export const ACTIVITY_IDS = {
  perksQuirks: (hatId: string) => `perksquirks-${hatId}`,
  jobGear: (hatId: string) => `jobgear-${hatId}`,
  highSchoolPriorities: (hatId: string) => `highschoolpriorities-${hatId}`,
  afterHighSchool: (hatId: string) => `afterhighschool-${hatId}`,
} as const;
